import { PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary/dist/react-error-boundary';
import { ApiError } from '/src/api';
import { RootErrorPage } from '/src/components';
import { config } from '/src/config';
import { Nullable } from '/src/lib/types';

export const RootErrorBoundary: React.FC<PropsWithChildren> = ({ children }) => {
  const handleError = (error: ApiError, stack?: Nullable<string>) => {
    if (config.nodeEnv === 'development') {
      console.error('Caught error at root error boundary: %O\nStack trace: %O', error, stack);
    }
  };

  return (
    <ErrorBoundary
      fallbackRender={({ error, resetErrorBoundary }) => (
        <RootErrorPage error={error} resetErrorBoundary={resetErrorBoundary} />
      )}
      onError={(error, { componentStack }) => handleError(error as ApiError, componentStack)}
    >
      {children}
    </ErrorBoundary>
  );
};
